import Vue from "vue";
import VueRouter from "vue-router";
import { isUserLoggedIn } from "@/auth/utils";
// import useJwt from "@/auth/jwt/useJwt";
import { i18n } from "../main";
import checkPlan from "@/middleware/checkPlan";

Vue.use(VueRouter);

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("@/views/Home.vue"),
      meta: {
        pageTitle: "Home",
        breadcrumb: [
          {
            text: "Home",
            active: true,
          },
        ],
      },
    },

    {
      path: "/policies",
      name: "policies",
      component: () => import("@/views/Policies.vue"),
      meta: {
        pageTitle: "policies",
        breadcrumb: [
          {
            text: "policies",
            active: true,
          },
        ],
      },
    },
    {
      path: "/second-page",
      name: "second-page",
      component: () => import("@/views/SecondPage.vue"),
      meta: {
        pageTitle: "Second Page",
        breadcrumb: [
          {
            text: "Second Page",
            active: true,
          },
        ],
      },
    },
    {
      path: "/login/advertisements",
      name: "login-advertisements",
      component: () => import("@/views/Login.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/Login-ads.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/under-maintenance",
      name: "misc-under-maintenance",
      component: () =>
        import("@/views/pages/miscellaneous/UnderMaintenance.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/register/advertisements",
      name: "register-advertisement",
      component: () => import("@/views/Register.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/register",
      name: "register",
      component: () => import("@/views/Register-ads.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/about",
      name: "about",
      component: () => import("@/views/About.vue"),
      meta: {
        layout: "full",
      },
    },

    {
      path: "/account/forgot-password",
      name: "auth-forgot-password",
      component: () => import("@/views/ForgotPassword.vue"),
      meta: {
        layout: "full",
        resource: "Auth",
        redirectIfLoggedIn: true,
      },
    },
    {
      path: "/reset-password",
      name: "auth-reset-password-v1",
      component: () => import("@/views/ResetPassword-v1.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/account/reset-password-email",
      name: "reset-password-email-v1",
      component: () => import("@/views/ResetPasswordEmail-v1.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/verify-email",
      name: "verify-email",
      component: () => import("@/views/VerifyEmail.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/pricing",
      name: "pricing",
      component: () => import("@/views/Pricing.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/questions",
      name: "questions",
      component: () => import("@/views/Questions.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/videos/advertisement",
      name: "videos-advertisement",
      component: () => import("@/views/Videos.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/free-digital-invoices",
      name: "free-digital-invoices",
      component: () => import("@/views/FreeDigitalInvoices.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/free-digital-invoices/preview",
      name: "free-digital-invoices-preview",
      component: () => import("@/views/FreeDigitalInvoicesPreview.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/why-choose-us",
      name: "why-choose-us",
      component: () => import("@/views/WhyChooseUs.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/features",
      name: "features",
      component: () => import("@/views/Features.vue"),
      meta: {
        layout: "full",
      },
    },

    {
      path: "/error-404",
      name: "error-404",
      component: () => import("@/views/error/Error404.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "*",
      redirect: "error-404",
    },
    // Companies routes starting from here
    {
      path: "/track-package",
      name: "companies",
      component: () => import("@/views/track-package-us/Index.vue"),
      meta: {
        pageTitle: "Companies",
        breadcrumb: [
          {
            text: "Track Package",
            active: true,
          },
        ],
        requiresPlanCheck: true,
      },
    },
    {
      path: "/track-package-de",
      name: "trackPackageDE",
      component: () => import("@/views/track-package-germany/index.vue"),
      meta: {
        pageTitle: "Companies",
        breadcrumb: [
          {
            text: "Track Package",
            active: true,
          },
        ],
        requiresPlanCheck: true,
      },
    },
    {
      path: "/track-package-uk",
      name: "trackPackageUK",
      component: () => import("@/views/track-package-uk/index.vue"),
      meta: {
        pageTitle: "Companies",
        breadcrumb: [
          {
            text: "Track Package",
            active: true,
          },
        ],
        requiresPlanCheck: true,
      },
    },
    {
      path: "/track-package-ca",
      name: "trackPackageCA",
      component: () => import("@/views/track-package-canada/index.vue"),
      meta: {
        pageTitle: "Companies",
        breadcrumb: [
          {
            text: "Track Package",
            active: true,
          },
        ],
        requiresPlanCheck: true,
      },
    },
    // bulk-tracking
    {
      path: "/bulk-tracking",
      name: "bulktracking",
      component: () => import("@/views/bulk-tracking/index.vue"),
      meta: {
        pageTitle: "Bulk Tracking",
        breadcrumb: [
          {
            text: "Bulk Tracking",
            active: true,
          },
        ],
        requiresPlanCheck: true,
      },
    },
    // ebay search
    {
      path: "/ebay-search",
      name: "ebaySearch",
      component: () => import("@/views/Plans/Index.vue"),
      meta: {
        pageTitle: "Ebay Search",
        breadcrumb: [
          {
            text: "Ebay Search",
            active: true,
          },
        ],
        requiresPlanCheck: true,
      },
    },
    // Videos routes starting from here
    {
      path: "/videos",
      name: "videos",
      component: () => import("@/views/videos/Index.vue"),
      meta: {
        pageTitle: "Videos",
        breadcrumb: [
          {
            text: "Videos",
            active: true,
          },
        ],
      },
    },
    // Tickets routes starting from here
    {
      path: "/tickets",
      name: "tickets",
      component: () => import("@/views/tickets/Index.vue"),
      meta: {
        pageTitle: "Tickets",
        breadcrumb: [
          {
            text: "Tickets",
            active: true,
          },
        ],
      },
    },
    // My Plans routes starting from here
    {
      path: "/my-plans",
      name: "my-plans",
      component: () => import("@/views/Plans/Index.vue"),
      meta: {
        pageTitle: "Plans",
        breadcrumb: [
          {
            text: "Plans",
            active: true,
            resource: "Auth",
          },
        ],
      },
    },
    // Settings routes starting from here
    {
      path: "/settings",
      name: "settings",
      component: () =>
        import("@/views/pages/account-setting/AccountSetting.vue"),
      meta: {
        pageTitle: "Settings",
        breadcrumb: [
          {
            text: "Settings",
            active: true,
          },
        ],
      },
    },
    // Contacts routes starting from here
    {
      path: "/contacts",
      name: "contacts",
      component: () => import("@/views/Contacts/Index.vue"),
      meta: {
        pageTitle: "Contacts",
        breadcrumb: [
          {
            text: "Contacts",
            active: true,
          },
        ],
      },
    },
    // Affiliate Program routes starting from here
    {
      path: "/affiliate-program",
      name: "affiliate-program",
      component: () => import("@/views/affilate-program/Index.vue"),
    },
    {
      path: "/info",
      name: "info",
      component: () => import("@/views/info/Index.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/privacy-policies",
      name: "privacy-policies",
      component: () => import("@/views/privacy_policy/index.vue"),
      meta: {
        layout: "full",
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  i18n.locale = localStorage.getItem("language") || "en";
  return next();
});

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn();
  if (
    [
      "/",
      "home",
      "invoices",
      "apps-invoice-preview",
      "apps-invoice-edit",
      "apps-users-view",
      "apps-users-edit",
      "my-plans",
      "company-invoice-previews",
      "company-invoice-add",
      "company-invoice-edit",
      "affiliate-program",
      // "privacy-policies",
    ].includes(to.name)
  ) {
    if (!isLoggedIn) return next({ name: "login" });

    return next();
  }

  return next();
});

// middleware for track package
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresPlanCheck)) {
    checkPlan(to, from, next);
  } else {
    next(); // Always call next() to proceed
  }
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
